import { ERROR_CODES, redirectToErrorPage } from "@src/utils/sessionUtils";
import { NextRouter } from "next/router";

/**
 * システムの稼働時間をチェックし、稼働時間外の場合はSorryページにリダイレクトする
 * @param router Nextルーター
 * @returns システムが利用可能かどうか
 */
export const checkSystemAvailability = async (
  router: NextRouter
): Promise<boolean> => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/v1/systems/availability`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": process.env.NEXT_PUBLIC_API_KEY || "",
        },
      }
    );

    if (response.status !== 200) {
      throw new Error("システム稼働時間チェック失敗", {
        cause: response,
      });
    }

    const data = await response.json();
    // console.log("システム稼働時間チェック結果:", data);

    // システムが稼働時間外の場合はSorryページにリダイレクト
    if (!data.is_available) {
      router.push("/sorry");
      return false;
    }

    return true;
  } catch (error) {
    console.error("システム稼働時間チェック失敗:", error);
    // エラー時も念のためErrorページにリダイレクト
    redirectToErrorPage(router, ERROR_CODES.SERVER_ERROR);
    return false;
  }
};
